import Link from 'next/link'
import { useState } from 'react'

const widgetSource = 'https://assets.calendly.com/assets/external/widget.js'
const consultationUrl = 'https://calendly.com/vwd/free-consultation?hide_gdpr_banner=1'
let widgetPromise

function loadCalendly() {
  if (window.Calendly?.initPopupWidget) return Promise.resolve(window.Calendly)
  if (widgetPromise) return widgetPromise

  widgetPromise = new Promise((resolve, reject) => {
    let script = document.querySelector(`script[src="${widgetSource}"]`)
    const existing = Boolean(script)
    if (!script) {
      script = document.createElement('script')
      script.src = widgetSource
      script.async = true
    }
    const cleanup = () => {
      script.removeEventListener('load', loaded)
      script.removeEventListener('error', failed)
    }
    const loaded = () => {
      cleanup()
      if (window.Calendly?.initPopupWidget) resolve(window.Calendly)
      else reject(new Error('Calendly did not initialize.'))
    }
    const failed = () => {
      cleanup()
      if (!existing) script.remove()
      reject(new Error('Calendly could not load. Please try again.'))
    }
    script.addEventListener('load', loaded)
    script.addEventListener('error', failed)
    if (!existing) document.head.appendChild(script)
  }).catch(error => {
    widgetPromise = undefined
    throw error
  })
  return widgetPromise
}

export default function BookingLink({ href = '/contact-us', children, onClick, ...props }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const schedulingUrl = href === '/contact-us'
    ? consultationUrl
    : typeof href === 'string' && href.startsWith('https://calendly.com/') ? href : null

  const openBooking = async event => {
    onClick?.(event)
    if (!schedulingUrl || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    if (loading) return
    setLoading(true)
    setError('')
    try {
      const calendly = await loadCalendly()
      calendly.initPopupWidget({ url: schedulingUrl })
    } catch (failure) {
      setError(failure.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Link {...props} prefetch={schedulingUrl ? false : props.prefetch} href={href} onClick={openBooking} aria-haspopup={schedulingUrl ? 'dialog' : undefined} aria-busy={loading || undefined}>
        {children}
      </Link>
      {loading && <span className="sr-only" role="status">Opening appointment scheduler…</span>}
      {error && <span className="block text-sm text-red-700" role="alert">{error}</span>}
    </>
  )
}
